import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./mantine-styles";
import { UiProvider } from "./ui";
import "./style.css";
import "./mobile.css";
import "./framework.css";
import "./tasks.css";
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <UiProvider>
      <App />
    </UiProvider>
  </React.StrictMode>,
);
